import { Box, TextField, Tooltip, IconButton, Button, LinearProgress } from '@mui/material'
import { Refresh as RefreshIcon, Add as AddIcon, Category as CategoryIcon } from '@mui/icons-material'
import { useEffect } from 'react'
import { useTypeTaskContext } from '../../../shared/context/typeTaskContext'
import { useUtiles } from '../../../shared/context/utilesContext'
import CreateTypeTaskComponent from './CreateTypeTaskComponent'
import { useTaskContext } from '../../../shared/context/taskContext'


export default function TypeTaskComponent({ functionSelect=null }) {
    const { typeTasks, getTypeTasks, createTypeTask, loadingTypeTask, loadingCreateTypeTask } = useTypeTaskContext()
    const { restorePreviousComponent, setAlertSnackbar, saveCurrentComponent, openSilderWith , toogleOpenSilder} = useUtiles()
    const { setTask } = useTaskContext()
    useEffect(() => {
        getTypeTasks()
    }, [])

    const handleSearch = (e) => {
        const value = e.target.value
        if (value) {
            getTypeTasks({ value })
        }
    }

    const handleCreateTypeTask = async () => {
        
        openSilderWith(
            <CreateTypeTaskComponent />,
            500,
            'Crear Tipo de Tarea'
        )
        saveCurrentComponent()
    }

    const handleSelectTypeTask = (typeTask) => {

        if (functionSelect) {
            functionSelect(typeTask)
            restorePreviousComponent()
        } else {
            setTask(prev => ({ ...prev, typeTask: typeTask }))
            toogleOpenSilder(null, 500, null)
        }
    }

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <TextField fullWidth placeholder="Escribe para buscar" size="small" onChange={handleSearch} />
                <Tooltip title="Refrescar">
                    <IconButton size="small" onClick={() => getTypeTasks()}>
                        <RefreshIcon />
                    </IconButton>
                </Tooltip>
            </Box>
            <Button
                size="small"
                variant="contained"
                color="primary"
                sx={{ mt: 1 }}
                startIcon={<AddIcon />}
                onClick={handleCreateTypeTask}
            >
                Crear Tipo de Tarea
            </Button>
            { loadingTypeTask && <LinearProgress sx={{ mt: 2 }} />}
            <Box sx={{ mt: 2, maxHeight: '70vh', overflow: 'auto' }}>
                {typeTasks.map((typeTask) => (
                    <Box 
                        key={typeTask.id}
                        onClick={() => handleSelectTypeTask(typeTask)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 1.5,
                            mb: 1,
                            borderRadius: 1,
                            boxShadow: '0 2px 4px rgba(0,0,0,0.08)',
                            bgcolor: 'background.paper',
                            transition: 'all 0.2s ease',
                            '&:hover': {
                                boxShadow: '0 4px 8px rgba(0,0,0,0.12)',
                                transform: 'translateY(-2px)'
                            },
                            cursor: 'pointer'
                        }}
                    >
                        <Box sx={{ 
                            mr: 2, 
                            color: 'primary.main',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                        }}>
                            <CategoryIcon sx={{ fontSize: 20 }} />
                        </Box>
                        <Box sx={{ fontWeight: 500 }}>
                            {typeTask.value}
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    )
} 